import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutLeftFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutLeftFull"><Path d="M3.5 3.5L3.5 3L3 3L3 3.5L3.5 3.5ZM20.5 3.5L21 3.5V3L20.5 3V3.5ZM20.5 20.5V21H21V20.5H20.5ZM3.5 20.5H3L3 21H3.5L3.5 20.5ZM3.5 4L20.5 4V3L3.5 3L3.5 4ZM20 3.5L20 20.5H21L21 3.5L20 3.5ZM20.5 20L3.5 20L3.5 21L20.5 21V20ZM4 20.5L4 3.5L3 3.5L3 20.5H4Z" fill="currentColor"/><Path d="M9 20.5L9 21H10L10 20.5H9ZM10 3.5L10 3L9 3L9 3.5L10 3.5ZM10 20.5L10 3.5L9 3.5L9 20.5H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutLeftFull;
